const getters = {
    totalCount(state) {
        let totalNum = 0;
        let totalPrice = 0;
        state.cartList.filter(item => {
            if (item.checked) {
                totalNum += 1;
                totalPrice += item.goods_num * item.sku_price.price;
            }
        })
        return {
            totalNum,
            totalPrice
        }
    }
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js